import * as React from "react";
import { styled } from "@mui/material";
import {
  MobileView,
  SingleViewPerLayoutBreakPoint,
} from "../../../util/aKaunGeneralUtil";
import { KahunPrimaryTypography } from "../../../style/akTypography";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]
const WelcomeMessageView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  flexGrow: 2,
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    width: "50%",
  },
}));

const UpperTitle = styled(KahunPrimaryTypography)(({ theme }) => ({
  color: KahunColorMap.Secondary,
  fontSize: "18px",
  lineHeight: "16px",
  fontWeight: 700,
  textTransform: "uppercase",
  [theme.breakpoints.down(MobileView)]: {
    align: "center",
    fontSize: "15px",
    lineHeight: "15px",
  },
}));

const MainTitle = styled("span")(({ theme }) => ({
  align: "center",
  fontSize: "32px",
  lineHeight: "36px",
  fontWeight: 700,
  marginTop: "11px",
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "22px",
    lineHeight: "28px",
  },
}));

const DescriptionText = styled("div")(({ theme }) => ({
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  color: "black",
  marginTop: "16px",
  marginBottom: "20px",
  [theme.breakpoints.down(MobileView)]: {
    marginTop: "12px",
    marginBottom: "17px",
    fontSize: "12px",
    lineHeight: "19px",
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]

export interface WelcomeMessageProps {
  className?: string;
  upperTitle?: string;
  mainTitle: string;
  descriptionText: string;
  extraElement?: JSX.Element;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LandingPageMessage = ({ ...props }: WelcomeMessageProps) => {
  return (
    <WelcomeMessageView className={props.className}>
      {!!props.upperTitle && (
        <UpperTitle className={"upper-title"}>{props.upperTitle}</UpperTitle>
      )}
      <MainTitle className={"main-title"}>{props.mainTitle}</MainTitle>
      <DescriptionText className={"description-text"}>
        {props.descriptionText}
      </DescriptionText>
      {props.extraElement}
    </WelcomeMessageView>
  );
};
